import './bootstrap';
import '../css/app.css';

import { createApp, h, DefineComponent, unref } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import i18n from './i18n'
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import Notifications from '@kyvg/vue3-notification'
import { LiveTranslatorPlugin, TranslationMeta } from 'vue-i18n-live-translator-plugin'
import { plugin as VueTippy } from 'vue-tippy'
import 'tippy.js/dist/tippy.css' // optional for styling
import 'tippy.js/themes/light.css'
import Role from './Enums/Role';
import * as Sentry from '@sentry/vue';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob<DefineComponent>('./Pages/**/*.vue')),
  setup({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) })
    if (import.meta.env.MODE === 'production') {
      Sentry.init({
        app,
        dsn: "https://b4fee5b5e83d8ff56678ebe9ec056f1c@o4509028397809664.ingest.de.sentry.io/4509649866784849",
        sendDefaultPii: false,
        integrations: [
          Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
          }),
        ],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
      });
    }
    app.use(plugin)
      .use(VueTippy)
      .use(i18n)
      .use(ZiggyVue)
      .use(Notifications)
    if (import.meta.env.MODE === 'development' || props.initialPage.props.auth.user?.role === Role.Admin) {
      app.use(LiveTranslatorPlugin, {
        i18n,
        translationLink(meta: TranslationMeta) {
          const locale = unref(i18n.global.locale)
          return `https://crowdin.com/editor/vestigia-database/all/en-${locale}?view=comfortable&filter=basic&value=0&search_scope=key&search_strict=1&search_full_match=0&case_sensitive=1#q=${meta.path}`
        },
        persist: true,
        root: document.getElementById('app')!,
        refreshRate: 100,
        checkVisibility: true,
      })
    }
    app.component('EasyDataTable', Vue3EasyDataTable)
    app.mount(el)
  },
  progress: {
    color: '#4B5563',
  },
});
